import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Calendar as Calendar_ } from 'react-big-calendar';
import styled from 'styled-components';
import { getTheme, ifProp, size } from 'mol-ui';

export const Calendar = styled(Calendar_)`
    /*  General */
    background-color: #FFF;
    border: 1px solid ${ getTheme('primaryColor') };
    font-weight: normal;
    height: 600px;
    ${ ({ loading }) => !loading ? '' : `
        opacity: 0.5;
        pointer-events: none;
    ` }

    ${ ({ view }) => view === 'month' && `
        height: 500px;
    ` }

    /* Header, first line of calendar */
    .rbc-header {
        font-weight: normal;
    }

    .rbc-toolbar-label {
        color: ${ getTheme('textColor') };
        font-size: 16px;
    }

    .rbc-time-view {
        border-top: 1px solid ${ getTheme('primaryColor') };
    }
    
    .rbc-month-view {
        border-top: 1px solid ${ getTheme('primaryColor') };
    }

    /* Event */
    .rbc-event-content {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .rbc-event:focus {
        outline: none;
    }

    /* Header, all day row */
    .rbc-allday-cell {
        display: none;
    }

    /* Current day */
    .rbc-today {
        background-color: ${ getTheme('primaryLighterColor') };
    }

    /* Current day - number */
    .rbc-date-cell.rbc-now {
        font-weight: bold;
    }

    /* Show more */
    .rbc-show-more {
        color: ${ getTheme('primaryColor') };
        font-weight: normal;
    }

    /* Agenda headers */
    .rbc-agenda-view table.rbc-agenda-table thead > tr > th {
        text-align: center;
    }

    /* Agenda fonts */
    .rbc-agenda-view {
        color: ${ getTheme('textColor') };
        font-size: 12px;
        padding: 5px;
    }


    /* Slot */

    .rbc-time-content > .rbc-day-slot {
        pointer-events: none;
        .rbc-timeslot-group {
            .rbc-time-slot {
                ${ ifProp('allowTurnCreation', 'cursor: pointer;') }
                pointer-events: all;
                :hover {
                    background-color: lightgray !important;
                }
            }
        }
    }

    .rbc-event {
        pointer-events: all;
    }

    /* Responsive */

    .rbc-btn-group > button {
        border-color: ${ getTheme('primaryColor') };
        border-radius: 0px;
        border-top-width: 0px;
    }

    .rbc-toolbar > .rbc-btn-group:first-child > button:first-child {
        border-left-width: 0px;
    }
    
    .rbc-toolbar > .rbc-btn-group:last-child > button:last-child {
        border-right-width: 0px;
    }


    ${ ({ view }) => `${ size.xs(`
        .rbc-btn-group > button {
            border-top-width: 1px;
        }

        .rbc-toolbar {
            align-items: center;
            flex-direction: column;
            font-size: 12px;
            justify-content: center;

            > span {
                display: flex;
                flex: 1;
                
                :first-child {
                    margin-bottom: 5px;
                    margin-top: 5px;
                }

                :last-child {
                    margin-top: 5px;
                }
            }

            > .rbc-btn-group:first-child > button:first-child {
                border-left-width: 1px;
            }

            > .rbc-btn-group:last-child > button:last-child {
                border-right-width: 1px;
            }
        }

        .rbc-month-view {
            overflow-x: auto;

            .rbc-month-header,
            .rbc-month-row {
                min-width: 700px;
            }
        }

        ${ ['week'].includes(view) && `
            .rbc-time-view {
                overflow-x: auto;

                .rbc-time-header,
                .rbc-time-content {
                    min-width: 700px;
                }
            }
        ` }
    `) }` }

`;
